export enum ActionType {
  UPDATE_USER = "update_user",
  UPDATE_PLACE = "update_place",
  UPDATE_AIRLINE = "update_airline"
}